import { StateCreator } from "zustand";

export interface CitationSlice {
  citation: string | undefined;
  setCitation: (citation: string | undefined) => void;
}

const createCitationSlice: StateCreator<
  CitationSlice,
  [],
  [],
  CitationSlice
> = (set) => ({
  citation: "",
  setCitation: (citation: string | undefined) => {
    set({ citation });
  },
});

export default createCitationSlice;
